export default "__VITE_ASSET__BcgHjtsT__"